export default "__VITE_ASSET__Coe8lFsd__"